module.exports = __webpack_public_path__ + "img/null_box.7803ce6b.png";